import { useEffect, useState } from "react";
import Button from "../../Button";
import { Url_Pdf, Url_Pdf_Info } from "../../../assets/URL'S/Url_Pdf";
import Loading from "../../../utils/Loading";
import api from "../../../Services/api";
import { Alert } from "../../../utils/Alert";
import {
  Background,
  Cardo,
  DivMain,
  DivSave,
  DivTitle,
  DragAndDropArea,
  DragAndDropArea2,
  FileDetails,
  FileInfo,
  PdfEmbed,
  HiddenFileInput,
  Instructions,
  DivTextarea,
  InputTextarea,
  FormDiv,
} from "../CardAddEditProgressao/style";

const CardEnviarProgressao = ({ Show, setShow, progressaoEdit, onSubmit }) => {
  if (!Show) return null;
  const [fileUrl, setFileUrl] = useState(null);
  const [fileSize, setFileSize] = useState({ bytes: null, kb: null, mb: null, gb: null });
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [loading, setLoading] = useState(false);

  // Estados para o formulário de envio
  const [file, setFile] = useState(null);
  const [newFileUrl, setNewFileUrl] = useState(null);
  const [observacao, setObservacao] = useState("");
  const [dragActive, setDragActive] = useState(false);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!Show) return null;
    setLoading(true);
    GetPdf();
  }, [Show, progressaoEdit]);

  async function GetPdf() {
    try {
      const res = await api.get(Url_Pdf(progressaoEdit.pdf), { responseType: "arraybuffer" });
      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setFileUrl(url);
      const { data } = await api.get(Url_Pdf_Info(progressaoEdit.pdf));
      setFileSize({
        bytes: data.fileSizeInBytes,
        kb: data.fileSizeInKB,
        mb: data.fileSizeInMB,
        gb: data.fileSizeInGB,
      });
    } catch (error) {
      console.error("Erro ao fazer a requisição", error);
      Alert({ tipo: "Erro", mensagem: error.response.data.erro || "Erro ao visualizar o pdf!" });
    } finally {
      setLoading(false);
    }
  }

  // Funções para lidar com upload de arquivo
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === "application/pdf") {
      const maxSizeInBytes = 5 * 1024 * 1024; // 5MB
      if (selectedFile.size > maxSizeInBytes) {
        Alert({
          tipo: "Alert",
          mensagem: `O arquivo selecionado é muito grande (${(selectedFile.size / (1024 * 1024)).toFixed(2)}MB/5MB).`,
        });
        return;
      }
      setFile(selectedFile);
      const fileUrl = URL.createObjectURL(selectedFile);
      setNewFileUrl(fileUrl);
    } else {
      selectedFile && Alert({ tipo: "Erro2", mensagem: "Apenas arquivos PDF são permitidos." });
      setFile(null);
      setNewFileUrl(null);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile && droppedFile.type !== "application/pdf") {
      Alert({ tipo: "Alert3", mensagem: "Somente arquivos PDF são aceitos." });
      return;
    }
    if (droppedFile) {
      const maxSizeInBytes = 5 * 1024 * 1024; // 5MB
      if (droppedFile.size > maxSizeInBytes) {
        Alert({
          tipo: "Alert",
          mensagem: `O arquivo é muito grande (${(droppedFile.size / (1024 * 1024)).toFixed(2)}MB/5MB).`,
        });
        return;
      }
      setFile(droppedFile);
      const fileUrl = URL.createObjectURL(droppedFile);
      setNewFileUrl(fileUrl);
    }
  };

  // Função para enviar a progressão
  const handleEnviar = async () => {
    if (!file && !observacao.trim()) {
      Alert({ tipo: "Alert3", mensagem: "Por favor, adicione um arquivo PDF e/ou uma observação." });
      return;
    }

    const { isConfirmed } = await Alert({
      tipo: "Alert",
      mensagem: "Deseja realmente enviar a progressão?",
    });

    if (isConfirmed) {
      try {
        setUploading(true);

        const formData = new FormData();
        formData.append("id_progressao", progressaoEdit.id);
        formData.append("observacao", observacao);

        if (file) {
          const agora = new Date();
          const [dataStr, horaStr] = agora.toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" }).split(" ");
          const [dia, mes, ano] = dataStr.split("/");
          const [horas, minutos, segundos] = horaStr.split(":");

          formData.append("id_pdf", `${ano}${mes}${dia}${horas}${minutos}${segundos}`.replace(",", ""));
          formData.append("file", file);
        } else {
          formData.append("sem_pdf", "true");
        }

        if (onSubmit) {
          console.log(
            "1- Submitting formData:",
            formData.get("file"),
            formData.get("observacao"),
            formData.get("id_progressao"),
            formData.get("id_pdf")
          );
          await onSubmit(formData);
        } else {
          console.log(
            "2- Submitting formData:",
            formData.get("file"),
            formData.get("observacao"),
            formData.get("id_progressao")
          );
          const response = await api.put("/aluno/enviar-progressao", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          if (response.status === 200) {
            Alert({ tipo: "Sucesso2", mensagem: "Progressão enviada com sucesso!" });
            setShow(false);
          }
        }
      } catch (error) {
        console.error("Erro ao enviar progressão:", error);
        Alert({ tipo: "Erro", mensagem: "Erro ao enviar a progressão. Tente novamente." });
      } finally {
        setUploading(false);
      }
    }
  };

  const PC = windowSize.width >= 1000;
  const Poket = windowSize.width <= 600;

  function Fechar(e) {
    e.preventDefault();
    setShow(false);
    // Limpar estados ao fechar
    setFile(null);
    setNewFileUrl(null);
    setObservacao("");
    setDragActive(false);
    if (newFileUrl && newFileUrl.startsWith("blob:")) {
      URL.revokeObjectURL(newFileUrl);
    }
  }

  return (
    <Background>
      <Cardo>
        <DivTitle>
          <h1>Enviar Progressão Parcial</h1>
        </DivTitle>

        {/* Formulário para envio */}
        <FormDiv
          $border={true}
          $padding={true}
          $overflow={true}
          $flex={true}
          style={{
            marginBottom: "20px",
          }}
        >
          {/* Área para upload de PDF */}
          <div style={{ width: "100%" }}>
            {newFileUrl ? (
              <div style={{ width: "100%" }}>
                <PdfEmbed
                  src={newFileUrl}
                  title="PDF Anexado"
                  style={{
                    height: "300px",
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "end",
                    gap: "1rem",
                    width: "100%",
                  }}
                />
              </div>
            ) : (
              <DragAndDropArea
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                dragActive={dragActive}
                style={{ height: "150px" }}
              >
                <Instructions>
                  {dragActive ? (
                    "Solte o arquivo aqui..."
                  ) : (
                    <p>
                      Arraste (ou clique aqui) um arquivo <strong>PDF</strong> para anexar à sua entrega.
                      <br />
                      <small style={{ fontSize: "0.8rem" }}>(Tamanho máximo: 5MB)</small>
                    </p>
                  )}
                </Instructions>
                <HiddenFileInput type="file" accept=".pdf" onChange={handleFileChange} />
              </DragAndDropArea>
            )}
          </div>
        </FormDiv>

        {/* Campo para observação/mensagem */}
        <DivTextarea style={{ padding: "0 20px" }}>
          <label htmlFor="observacao">
            Observações/Mensagem para o Professor:
            <span style={{ fontSize: "0.9em" }}>{observacao?.length ?? 0}/1000</span>
          </label>
          <InputTextarea
            id="observacao"
            type="text"
            rows={5}
            value={observacao}
            maxLength={1000}
            placeholder="Escreva suas observações, dúvidas ou comentários sobre a progressão..."
            onChange={(e) => setObservacao(e.target.value)}
          />
        </DivTextarea>

        <DivSave>
          <Button
            event={Fechar}
            width={Poket ? "4rem" : "10rem"}
            placeholder={"Cancelar"}
            background={"linear-gradient(135deg, #6c757d 0%, #495057 100%)"}
            borderRadius="10px"
            padding={!PC && "10px"}
            fontSize={!PC && "12px"}
          />
          {newFileUrl ? (
            <div style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ fontSize: "0.9em", color: "#666" }}>
                Arquivo: {file?.name.length > 50 ? `${file?.name.slice(0, 50)}...` : file?.name}
              </span>
              <Button
                event={() => {
                  setFile(null);
                  setNewFileUrl(null);
                  if (newFileUrl && newFileUrl.startsWith("blob:")) {
                    URL.revokeObjectURL(newFileUrl);
                  }
                }}
                placeholder="Remover"
                background="linear-gradient(135deg, #dc3545 0%, #c82333 100%)"
                borderRadius="5px"
                fontSize="12px"
              />
            </div>
          ) : null}
          <Button
            event={handleEnviar}
            width={Poket ? "4rem" : "10rem"}
            placeholder={uploading ? "Enviando..." : "Enviar"}
            background={"linear-gradient(135deg, #28a745 0%, #20c997 100%)"}
            borderRadius="10px"
            padding={!PC && "10px"}
            fontSize={!PC && "12px"}
            disabled={uploading}
          />
        </DivSave>
      </Cardo>
    </Background>
  );
};

export default CardEnviarProgressao;
